export const testimonials = [
	{
		id: 1,
		title: 'Technical Excellence',
		quote:
			'With over a decade of experience in software development, I bring enterprise-grade solutions to businesses of all sizes. From custom applications to scalable infrastructure, I deliver robust, maintainable code that drives business growth.',
		author: 'Core Expertise',
		position: 'Full-Stack Development',
		company: 'Technical Leadership',
	},
	{
		id: 2,
		title: 'Strategic Innovation',
		quote:
			'I combine technical expertise with business acumen to create solutions that not only work flawlessly but also drive real business value. Every project is an opportunity to innovate and optimize.',
		author: 'Business Strategy',
		position: 'Technology Consulting',
		company: 'Digital Transformation',
	},
	{
		id: 3,
		title: 'Future-Ready Solutions',
		quote:
			'Built on modern tech stack and best practices, my solutions are designed to scale with your business. From cloud architecture to AI integration, I ensure your technology foundation is future-proof.',
		author: 'Modern Architecture',
		position: 'Cloud & AI Solutions',
		company: 'Scalable Systems',
	},
];
